import React, { useEffect, useState } from "react";
import { collection, getDocs } from 'firebase/firestore';
import { Container, Row, Col } from 'react-bootstrap';

import { firestore } from '../../../firebase';
import ProductCard from "../../../components/ProductCard";

const Main = () => {
    const [products, setProducts] = useState([]);
    const productsCollectionRef = collection(firestore, 'produtos')

    useEffect(() => {
        const getProducts = async () => {
            const data = await getDocs(productsCollectionRef);
            setProducts(data.docs.map((doc) => ({ ...doc.data() })))
        }

        getProducts()
    }, [])

    return (
        <Container>
            <Row>
                <Col>
                    <h1 className="display-2">Bem-vindo!</h1>
                </Col>
            </Row>
            <br />
            <Row> 
                    {products.map((product) => {
                        return <Col sm={4}><ProductCard header={product.name} img={product.thumbnail} /></Col> 
                    })}
            </Row>
            <Row>
                <Col>
                    <h4>Se algum dos bonecos te interessou, <a href="/products">confira se está disponível</a>, se não estiver, entre em contato pelo <a href="https://www.instagram.com/amigurumi.magia/">instagram</a> e faça seu pedido personalizado!</h4>
                </Col>
            </Row>
        </Container>
    )
}

export default Main;
